<template>
    <div>
        <page-header :title="$t('pages.admin.blog.index.title')" icon-class="mdi mdi-television">
            <div class="text-right">
                <router-link tag="a" :to="{name: 'admin.blog.create'}" class="text-primary font-weight-bold">
                    <i class="mdi mdi-plus"></i> {{ $t('actions.create') }}
                </router-link>
            </div>
        </page-header>

        <div class="card shadow-sm">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table table-striped table-borderless">
                        <thead>
                        <tr>
                            <th>{{ $t('pages.admin.blog.model.title') }}</th>
                            <th>{{ $t('pages.admin.blog.model.files_count') }}</th>
                            <th>{{ $t('pages.admin.blog.model.date_and_time') }}</th>
                            <th>{{ $t('actions.actions') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="blogpost in blogPosts">
                            <td>
                                <img :src="blogpost.thumbnail_url" :alt="blogpost.title" class="img-thumbnail mr-2">
                                {{ blogpost.title }}
                            </td>

                            <td>{{ blogpost.files.length }}</td>
                            <td>{{ $date(blogpost.created_at).format('DD.MM.YYYY HH:mm') }}</td>

                            <td>
                                <router-link tag="button" class="btn btn-outline-warning btn-sm" :to="{name: 'admin.blog.edit', params: {postId: blogpost.id}}">
                                    <i class="mdi mdi-pencil"></i>
                                </router-link>

                                <button class="btn btn-outline-danger btn-sm float-right" @click="selectedBlogPost = blogpost">
                                    <i class="mdi mdi-trash-can"></i>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="mt-3">
                    <pagination
                        :data="paginationData"
                        @pagination-change-page="getBlogPosts"
                    ></pagination>
                </div>

                <blog-delete-modal :selected="selectedBlogPost" @post-deleted="onBlogPostDeleted" @modal-close="selectedBlogPost = null"></blog-delete-modal>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "../../Includes/PageHeader";
import AdminBlogRepository from "../../../repositories/Admin/AdminBlogRepository";
import BlogDeleteModal from "./BlogDeleteModal";
export default {
name: "BlogManagement",
    components: {BlogDeleteModal, PageHeader},
    data: () => ({
        paginationData: {},
        selectedBlogPost: null,
    }),
    mounted() {
        this.getBlogPosts();
    },
    computed: {
        blogPosts() {
            return this.paginationData?.data;
        }
    },
    methods: {
        getBlogPosts(page = 1) {
            AdminBlogRepository.getBlogPosts(page).then(res => {
                this.paginationData = res.data;
            });
        },
        onBlogPostDeleted() {
            this.$snotify.success(this.$t('actions.deleted'));
            this.selectedBlogPost = null;
            this.getBlogPosts(1);
        }
    }
}
</script>

<style scoped>

</style>
